// src/router/novo-colaborador.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa. allowImageUpload só usa a listagem (envio da foto corporativa):
// a ficha (cadastro, edição, detalhe, chip) é dado de RH e a API só a libera para peopleCulture.
const ROLES = ['peopleCulture', 'allowImageUpload']
const ROLES_FICHA = ['peopleCulture']

const breadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Novos Colaboradores',
        to: 'NovoColaboradorList'
    }
]

export default [
    {
        path: '/novo-colaborador',
        name: 'NovoColaboradorList',
        component: () => import('@/views/PeopleCulture/NovoColaborador/ListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novos Colaboradores',
            breadcrumb: breadCrumb
        },
    },
    {
        path: '/novo-colaborador/novo',
        name: 'NovoColaborador',
        component: () => import('@/views/PeopleCulture/NovoColaborador/NovoPage.vue'),
        meta: {
            roles: ROLES_FICHA,
            title: 'Novo Colaborador',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Colaborador',
                    to: 'NovoColaborador'
                }
            ]
        }
    },
    {
        path: '/novo-colaborador/:id/edit',
        name: 'NovoColaboradorEdit',
        component: () => import('@/views/PeopleCulture/NovoColaborador/NovoPage.vue'),
        meta: {
            roles: ROLES_FICHA,
            title: 'Detalhes do Colaborador',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Colaborador',
                    to: 'NovoColaborador'
                }
            ]
        }
    },
    {
        path: '/novo-colaborador/:id/solicitacao-celular-chip',
        name: 'NovoColaboradorSolicitacaoCelularChip',
        component: () => import('@/views/PeopleCulture/NovoColaborador/SolicitacaoChipCelular.vue'),
        meta: {
            roles: ROLES_FICHA,
            title: 'Detalhes da Solicitação de Acessos & Chip/Celular',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Solicitação de Acessos & Chip/Celular',
                    to: 'NovoColaborador'
                }
            ]
        }
    },
    {
        path: '/novo-colaborador/:id/details',
        name: 'NovoColaboradorDetail',
        component: () => import('@/views/PeopleCulture/NovoColaborador/Details/DetailPage.vue'),
        meta: {
            roles: ROLES_FICHA,
            title: 'Detalhes do Colaborador',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Colaborador',
                    to: 'NovoColaborador'
                }
            ]
        }
    },
    {
        path: '/ficha-cadastro/:id/:checkNumber',
        name: 'NovoColaboradorFichaCadastro',
        component: () => import('@/views/PeopleCulture/NovoColaborador/PublicForm/NovoPage.vue'),
        meta: {
            public: true,
            layout: "empty",
            title: null,
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Ficha cadastro',
                    to: 'NovoColaboradorFichaCadastro'
                }
            ]
        }
    },
];
